module.exports = __webpack_public_path__ + "img/ico_vod_age_19.c4200620.png";